import moment from "moment-timezone";
import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Grid, Icon } from "semantic-ui-react";

import CopyString from "../../utils/CopyString.jsx";
import EntityLink from "../../utils/EntityLink.jsx";

import { MODIFIED_AT_TIME_FORMAT } from "../../config.js";
import { ICON_MAP } from "../../../constants/iconMap.js";
import {
  GOLDEN_IMAGE_TYPES,
  IMAGE_VENDOR_COPY_KEYS
} from "../../../constants/images.js";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";
import imageSelector from "../../../state/reducers/images/imageSelector.js";

class ImageDetailsView extends PureComponent {
  static propTypes = {
    data: PropTypes.object,
    disabled: PropTypes.bool,
    copyKey: PropTypes.string.isRequired,

    source: PropTypes.object,
    regions: PropTypes.array,
    provider: PropTypes.object,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false,
    copyKey: "image.details_panel"
  };

  // -- RENDER -- //

  renderVendorName() {
    const { data, copy } = this.props;

    if (!data.vendor) return "";

    const key =
      GOLDEN_IMAGE_TYPES.find(item => item === data["@type"]) || data.vendor;

    return copy(`image_vendors.${IMAGE_VENDOR_COPY_KEYS[key]}`);
  }

  renderRegionsList() {
    const { regions, copyKey, copy } = this.props;

    if (!regions || regions.length < 1) return null;

    const regionNames = regions
      .map(region => {
        return region.name;
      })
      .join(", ");

    const labelCopyKey = regions.length > 1 ? "regions" : "region";

    return (
      <Fragment>
        <br />
        <strong>{copy(`${copyKey}.${labelCopyKey}`)}: </strong>
        {regionNames}
      </Fragment>
    );
  }

  render() {
    const { data, source, provider, copyKey, copy } = this.props;

    if (!data) return null;

    return (
      <Grid stackable className="clear-both">
        <Grid.Row columns={1}>
          <Grid.Column>
            <p>
              {data.id && data.name && (
                <Fragment>
                  <strong>id: </strong>
                  <CopyString copyText={data.id} displayText={data.id} />
                  <br />
                  <strong>{copy(`${copyKey}.name`)}: </strong>
                  <EntityLink entity={data} />
                </Fragment>
              )}

              {data.description && (
                <Fragment>
                  <br />
                  <strong>{`${copy(`${copyKey}.description`)}: `}</strong>
                  {`${data.description}`}
                </Fragment>
              )}
              {data.createdAt && (
                <Fragment>
                  <br />
                  <strong>{`${copy(`${copyKey}.created_at`)}: `}</strong>
                  {moment(data.createdAt).format(MODIFIED_AT_TIME_FORMAT)}
                </Fragment>
              )}
              {data.updatedAt && (
                <Fragment>
                  <br />
                  <strong>{`${copy(`${copyKey}.last_updated`)}: `}</strong>
                  {moment(data.updatedAt).format(MODIFIED_AT_TIME_FORMAT)}
                </Fragment>
              )}
            </p>
            <p>
              {data.vendor && (
                <Fragment>
                  <strong>{copy(`${copyKey}.image_vendor`)}: </strong>
                  {this.renderVendorName()}
                </Fragment>
              )}
              {data.operatingSystem && (
                <Fragment>
                  <br />
                  <strong>{copy(`${copyKey}.operating_system`)}: </strong>
                  {copy(`operating_systems.${data.operatingSystem}`)}
                  <Icon name={ICON_MAP[data.operatingSystem]} />
                </Fragment>
              )}
              {data.volumeSize && (
                <Fragment>
                  <br />
                  <strong>{copy(`${copyKey}.volume_size`)}: </strong>
                  {`${data.volumeSize}`}
                </Fragment>
              )}
              {provider && (
                <Fragment>
                  <br />
                  <strong>{copy(`${copyKey}.provider`)}: </strong>
                  {`${provider.name}`}
                </Fragment>
              )}
              {this.renderRegionsList()}
            </p>
            {source && (
              <p>
                <strong>{copy(`${copyKey}.source`)}: </strong>
                <EntityLink entity={source} />
              </p>
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state, props) => ({
  source: imageSelector.selectImageSourceByEntity(state, props),
  regions: imageSelector.selectRegionsByEntity(state, props),
  provider: imageSelector.selectProviderByEntityService(state, props),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ImageDetailsView);
